import React from 'react';
import PropTypes from 'prop-types';
import SocialMedium from '../SocialMedium';

import './index.scss';

const SocialMediumItems = ({mediums, onClick}) => (
    <ul className="social-mediums">
        {mediums.map((item, index) => (
            <SocialMedium key={index} socialMedium={item} onClick={() => onClick(item.medium)}/>
        ))}
    </ul>
);

SocialMediumItems.propTypes = {
    mediums: PropTypes.arrayOf(PropTypes.shape({
        medium: PropTypes.string.isRequired,
        isVisited: PropTypes.bool,
        isLoading: PropTypes.bool
    })).isRequired,
    onClick: PropTypes.func.isRequired
};

export default SocialMediumItems;



// WEBPACK FOOTER //
// ./src/components/SocialMediumItems/index.js